export const DICE_VALUE_DOTS_MAP = {
  1: [ 4 ],
  2: [ 0, 8 ],
  3: [ 0, 4, 8 ],
  4: [ 0, 2, 6, 8 ],
  5: [ 0, 2, 4, 6, 8 ],
  6: [ 0, 2, 3, 5, 6, 8 ],
};

export const DOT_POSITIONING_MAP = {
  0: { cx: 7, cy: 7 },
  1: { cx: 16, cy: 7 },
  2: { cx: 25, cy: 7 },
  3: { cx: 7, cy: 16 },
  4: { cx: 16, cy: 16 },
  5: { cx: 25, cy: 16 },
  6: { cx: 7, cy: 25 },
  7: { cx: 16, cy: 25 },
  8: { cx: 25, cy: 25 },
};
